import { Chip, CopyElement } from "@ui";
import style from "./Header.module.scss";
import { MenuButton, Notifications } from "./components";
import { useGetUserQuery } from "@RTKQuery/user/auth/auth";
import { Link } from "react-router-dom";

export function Header({
  balance = false,
  notifications = false,
  userId = false,
}: {
  balance?: boolean,
  notifications?: boolean,
  userId?: boolean
}) {
  const { data } = useGetUserQuery();

  return (
    <header id="zoom">
      <div className={style.limit}>
        <Link to={"/"} className={style.logo}>
          <img src="/image/logo.svg" alt="logo" />
          <p className={style.name}>rocketproxy</p>
        </Link>
        <div className={style.infoPanel}>
          <div className="flex items-center gap-[20px] max-sm:flex-col-reverse max-sm:gap-[10px]">
            {notifications && <Notifications />}
            {userId && <CopyElement
              alignCopyButton="left"
              element={<p className={style.userID}>Id: {data?.id}</p>}
              copyText={String(data?.id || 0)}
            />}
          </div>
          <div className="flex items-center gap-[20px] max-sm:flex-col-reverse max-sm:gap-[10px] min-w-0">
            {balance && <Chip
              text={"$" + (data?.balance || 0)}
              size="big"
              color="green"
              icon={
                <svg className="max-sm:hidden" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M15.6489 6.68065C15.6025 6.6777 15.552 6.67771 15.4996 6.67774H15.4865H13.4312C11.7372 6.67774 10.2876 8.02163 10.2876 9.77415C10.2876 11.5267 11.7372 12.8706 13.4312 12.8706H15.4865H15.4996C15.552 12.8706 15.6025 12.8706 15.6489 12.8676C16.3371 12.8239 16.9456 12.2812 16.9968 11.5232C17.0002 11.4735 17.0001 11.4199 17.0001 11.3703V11.3568V8.19154V8.17802C17.0001 8.12839 17.0002 8.07484 16.9968 8.02511C16.9456 7.26717 16.3371 6.72444 15.6489 6.68065ZM13.249 10.5998C13.6851 10.5998 14.0387 10.2302 14.0387 9.77415C14.0387 9.31813 13.6851 8.94846 13.249 8.94846C12.8129 8.94846 12.4593 9.31813 12.4593 9.77415C12.4593 10.2302 12.8129 10.5998 13.249 10.5998Z" fill="#14AF20" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M15.4992 14.1102C15.6213 14.1071 15.7138 14.2211 15.6806 14.3397C15.5162 14.9279 15.2551 15.4293 14.8362 15.8515C14.2231 16.4694 13.4456 16.7436 12.485 16.8737C11.5517 17.0002 10.3591 17.0002 8.85332 17.0002H7.12231C5.61658 17.0002 4.42396 17.0002 3.49059 16.8737C2.53 16.7436 1.75252 16.4694 1.13938 15.8515C0.526229 15.2335 0.254124 14.45 0.124977 13.4819C-0.00051345 12.5412 -0.000496389 11.3393 -0.000487889 9.82184V9.72868C-0.00050489 8.21118 -0.00051345 7.00929 0.124977 6.06863C0.254124 5.10055 0.526229 4.31699 1.13938 3.69905C1.75252 3.08112 2.53 2.80689 3.49059 2.67674C4.42395 2.55027 5.61657 2.55028 7.12231 2.55029H8.85332C10.3591 2.55028 11.5517 2.55027 12.485 2.67674C13.4456 2.80689 14.2231 3.08112 14.8362 3.69905C15.2551 4.12123 15.5162 4.62262 15.6806 5.21088C15.7138 5.32943 15.6213 5.44348 15.4992 5.44028L13.4314 5.44029C11.1072 5.44029 9.05878 7.29064 9.05878 9.77526C9.05878 12.2599 11.1072 14.1102 13.4314 14.1102H15.4992ZM3.07194 5.85314C2.73257 5.85314 2.45745 6.1304 2.45745 6.47242C2.45745 6.81447 2.73257 7.09174 3.07194 7.09174H6.34918C6.68855 7.09174 6.96369 6.81447 6.96369 6.47242C6.96369 6.1304 6.68855 5.85314 6.34918 5.85314H3.07194Z" fill="#14AF20" />
                  <path d="M4.90967 1.72072L6.57473 0.494067C7.46889 -0.164689 8.68036 -0.164689 9.57452 0.494067L11.2483 1.72717C10.5485 1.69995 9.76696 1.69997 8.91013 1.69999H7.06504C6.28209 1.69997 5.562 1.69996 4.90967 1.72072Z" fill="#14AF20" />
                </svg>
              }
              aligtIcon="left"
            />}
            <div className={style.name}>{data?.first_name} {data?.last_name}</div>
          </div>
        </div>
        <MenuButton />
      </div>
    </header>
  );
}

